import { createApi } from '@reduxjs/toolkit/query/react';

import { apiGocardlessOAuth } from '~constants/api';

import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';

import { GocardlessConnection, OAuthExchangeRequest, OAuthInitiateResponse } from '~direct-debits/models';

export const oauthApi = createApi({
  reducerPath: 'directDebitsOAuthApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiGocardlessOAuth }),
  endpoints: (builder) => ({
    initiateOAuth: builder.query<OAuthInitiateResponse, { initial_view: 'login' | 'signup' }>({
      query: ({ initial_view }) => ({
        url: '/initiate',
        method: 'GET',
        params: { initial_view },
      }),
      transformResponse: (payload) => unwrap<OAuthInitiateResponse>(payload),
    }),
    exchangeToken: builder.mutation<GocardlessConnection, OAuthExchangeRequest>({
      query: (body) => ({
        url: '/exchange',
        method: 'POST',
        body,
      }),
      transformResponse: (payload) => unwrap<GocardlessConnection>(payload),
    }),
  }),
});

export const { useLazyInitiateOAuthQuery, useExchangeTokenMutation } = oauthApi;
